import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, AfterViewInit } from '@angular/core';
import { RouterModule } from '@angular/router';


import { ApiService } from 'src/app/shared/api/api.service';
import { AuthRoles } from 'src/app/shared/common/auth-roles';
import { ShopTypeEnum } from 'src/app/shared/enums/shop-type';
import { AuthService } from 'src/app/shared/services/auth.service';

import { MENU } from './menu';
import { MenuItem } from './menu.model';

// Declare lucide for TypeScript
declare const lucide: any;

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterViewInit {

  menu: any;
  toggle: any = true;
  menuItems: MenuItem[] = [];
  isMobileMenuOpen: boolean = false;
  sidebarSize: string | null = null;
  isDesktop: boolean = false;
  isMobile: boolean = false;
  activeExternalMenuId?: number;
  private canAccessPublishing = false;
  private canAccessDataSharing = false;
  @Output() mobileMenuButtonClicked = new EventEmitter();

  constructor(private api: ApiService,
    private authService: AuthService) {
  }

  async ngOnInit() {
    await Promise.all([this.resolvePublishingAccess(), this.resolveDataSharingAccess()]);
    this.setMenuItems();
    this.loadAutoLink();
    
    this.checkScreenSize();
    this.checkSidebarState();
    
    setInterval(() => {
      this.checkSidebarState();
    }, 100);
    
    window.addEventListener('resize', () => {
      this.checkScreenSize();
    });
  }

  /***
   * Activate droup down set
   */
  ngAfterViewInit() {
    this.initActiveMenu();
    // Initialize Lucide icons
    this.initLucideIcons();
  }

  private checkScreenSize() {
    this.isDesktop = window.innerWidth >= 768;
    this.isMobile = window.innerWidth < 768;
  }

  private checkSidebarState() {
    this.isMobileMenuOpen = document.body.classList.contains('vertical-sidebar-enable');
    this.sidebarSize = document.documentElement.getAttribute('data-sidebar-size');
  }

  initLucideIcons() {
    if (typeof lucide !== 'undefined') {
      lucide.createIcons();
    }
  }

  removeActivation(items: any) {
    items.forEach((item: any) => {
      if (item.classList.contains("menu-link")) {
        if (!item.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        (item.nextElementSibling) ? item.nextElementSibling.classList.remove("show") : null;
      }
      if (item.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item.classList.remove("active");
    });
  }

  toggleSubItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let isMenu = isCurrentMenuId.nextElementSibling as any;
    let dropDowns = Array.from(document.querySelectorAll('.sub-menu'));
    dropDowns.forEach((node: any) => {
      node.classList.remove('show');
    });

    let subDropDowns = Array.from(document.querySelectorAll('.menu-dropdown .nav-link'));
    subDropDowns.forEach((submenu: any) => {
      submenu.setAttribute('aria-expanded',"false");
    });
    
    if (event.target && event.target.nextElementSibling){
      isCurrentMenuId.setAttribute("aria-expanded", "true");
      event.target.nextElementSibling.classList.toggle("show");
    }
  };

  toggleExtraSubItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let isMenu = isCurrentMenuId.nextElementSibling as any;
    let dropDowns = Array.from(document.querySelectorAll('.extra-sub-menu'));
    dropDowns.forEach((node: any) => {
      node.classList.remove('show');
    });

    let subDropDowns = Array.from(document.querySelectorAll('.menu-dropdown .nav-link'));
    subDropDowns.forEach((submenu: any) => {
      submenu.setAttribute('aria-expanded',"false");
    });
    
    if (event.target && event.target.nextElementSibling){
      isCurrentMenuId.setAttribute("aria-expanded", "true");
      event.target.nextElementSibling.classList.toggle("show");
    }
  };

  // Click wise Parent active class add
  toggleParentItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    this.activeExternalMenuId = undefined;
    let dropDowns = Array.from(document.querySelectorAll('#navbar-nav .show'));
    dropDowns.forEach((node: any) => {
      node.classList.remove('show');
    });
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const iconItems = Array.from(ul.getElementsByTagName("a"));
      let activeIconItems = iconItems.filter((x: any) => x.classList.contains("active"));
      activeIconItems.forEach((item: any) => {
        item.setAttribute('aria-expanded', "false")
        item.classList.remove("active");
      });
    }
    isCurrentMenuId.setAttribute("aria-expanded", "true");
    if (isCurrentMenuId) {
      this.activateParentDropdown(isCurrentMenuId);
    }
    
    if (this.isMobile) {
      this.SidebarHide();
    }
  }

  toggleItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let isMenu = isCurrentMenuId.nextElementSibling as any;
    if (isMenu.classList.contains("show")) {
      isMenu.classList.remove("show");
      isCurrentMenuId.setAttribute("aria-expanded", "false");
    } else {
      let dropDowns = Array.from(document.querySelectorAll('#navbar-nav .show'));
      dropDowns.forEach((node: any) => {
        node.classList.remove('show');
      });
      (isMenu) ? isMenu.classList.add('show') : null;
      const ul = document.getElementById("navbar-nav");
      if (ul) {
        const iconItems = Array.from(ul.getElementsByTagName("a"));
        let activeIconItems = iconItems.filter((x: any) => x.classList.contains("active"));
        activeIconItems.forEach((item: any) => {
          item.setAttribute('aria-expanded', "false")
          item.classList.remove("active");
        });
      }
      isCurrentMenuId.setAttribute("aria-expanded", "true");
      if (isCurrentMenuId) {
        this.activateParentDropdown(isCurrentMenuId);
      }
    }
  }
  
  activateParentDropdown(item:any) {
    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

    if (parentCollapseDiv) {
        // to set aria expand true remaining
        parentCollapseDiv.classList.add("show");
        parentCollapseDiv.parentElement.children[0].classList.add("active");
        parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
        if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
            parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
            if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
                parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
            if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse")) {
                parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").classList.add("show");
                parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").previousElementSibling.classList.add("active");
            }
        }
        return false;
    }
    return false;
  }

  updateActive(event: any) {
    this.activeExternalMenuId = undefined;
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      this.removeActivation(items);
    }
    this.activateParentDropdown(event.target);
    
    if (this.isMobile) {
      this.SidebarHide();
    }
  }

  activateExternalItem(event: any, item: MenuItem) {
    this.toggleParentItem(event);
    this.activeExternalMenuId = item.id;
  }

  initActiveMenu() {
    const pathName = window.location.pathname;
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      let activeItems = items.filter((x: any) => x.classList.contains("active"));
      this.removeActivation(activeItems);

      let matchingMenuItem = items.find((x: any) => {
        return x.pathname === pathName;
      });
      if (matchingMenuItem) {
        this.activateParentDropdown(matchingMenuItem);
      }
    }
    
    // Re-initialize Lucide icons after DOM updates
    this.initLucideIcons();
  } 

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    var sidebarsize = document.documentElement.getAttribute("data-sidebar-size");
    if (sidebarsize == 'sm-hover-active') {
      document.documentElement.setAttribute("data-sidebar-size", 'sm-hover')
    } else {
      document.documentElement.setAttribute("data-sidebar-size", 'sm-hover-active')
    }
  }

  /**
   * SidebarHide modal
   * @param content modal content
   */
   SidebarHide() {
    document.body.classList.remove('vertical-sidebar-enable');
    this.checkSidebarState();
  }

  private async loadAutoLink() {
    const autoLink = await this.api.shopProducts.searchAsync({
      itemsPerPage: 0,
      pageNumber: 1,
      priceFrom: 0,
      priceTo: 99999,
      hasConfirmedFeedProduct: false,
      hasFeedProduct: true
    });

    const menuItem = MENU.find(x => x.id == 3);
    if(menuItem && menuItem.badge){
      menuItem.badge.text = `${autoLink.total}`;
    }
    // Menu Items
    this.setMenuItems();
    
    // Re-initialize Lucide icons after menu update
    setTimeout(() => {
      this.initLucideIcons();
    }, 100);
  }

  private setMenuItems() {
    this.menuItems = MENU.filter(item =>
      (!item.requiresPublishingAccess || this.canAccessPublishing) &&
      (!item.requiresDataSharingAccess || this.canAccessDataSharing)
    );
  }

  private async resolveDataSharingAccess(): Promise<void> {
    try {
      const retailer = await this.api.retailers.getByAuthAsync();
      this.canAccessDataSharing = retailer.enableDataSharing;
    } catch {
      this.canAccessDataSharing = false;
    }
  }

  private async resolvePublishingAccess() {
    if (!this.authService.hasRole(AuthRoles.SYSTEM_ADMIN)) {
      this.canAccessPublishing = false;
      return;
    }

    try {
      const shops = (await this.api.shops.searchAsync({
        itemsPerPage: 1,
        pageNumber: 1
      })).items;

      this.canAccessPublishing = !!shops?.length && (
        shops[0].type === ShopTypeEnum.Shopify ||
        shops[0].type === ShopTypeEnum.Lightspeed ||
        shops[0].type === ShopTypeEnum.LightspeedX
      );
    } catch {
      this.canAccessPublishing = false;
    }
  }

}
